import { type FunctionComponent } from "react";

import softPlanIcon from "images/Common/softPlanIcon.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedSoftPlan: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img alt="" src={softPlanIcon} style={baseProps.style} className={baseProps.className} />
    );
};
